// extracted by mini-css-extract-plugin
export default {"container":"CK-z","error":"DK-z","disabled":"EK-z","submit":"FK-z","option":"GK-z","success":"HK-z","failure":"IK-z"};